import {Component, OnDestroy, OnInit} from '@angular/core';
import { Category } from 'src/app/models/category';
import { takeWhile } from 'rxjs/operators';
import {CategoryService} from '../../services/category.service';
import {Shop} from "../../models/shop";
import {ShopService} from "../../services/shop.service";

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss'],
})
export class CategoryListComponent implements OnInit, OnDestroy {

  restaurantCategories: Category[];
  shop: Shop = new Shop();

  private isComponentActive = true;

  constructor(
    private categoryService: CategoryService,
    private shopService: ShopService
  ) { }

  ngOnInit() {
    this.isComponentActive = true;
    this.shopService.getCurrentShop().subscribe(shop => {
      if (shop) {
        this.shop = shop;
        this.categoryService.observeCategories()
            .pipe(takeWhile(() => this.isComponentActive))
            .subscribe(categories => {
              this.restaurantCategories = categories.filter(c => c.shopId === this.shop.uid);
            });
      }
    });
  }

  ngOnDestroy() {
    this.isComponentActive = false;
  }
}
